import React from 'react'
import Navbar from '../components/navbar/navbar'
import Footer from '../components/footer/footer'
import Instruction from './instruction'
function Generate() {
  return (
    <>
     
     <Navbar netnexa="DUBU" button="Learn More" />
   <div className='instruction'>  <Instruction /></div>
 
    
    <div className='center'>
   
     
      <div className="form-container">
      <div className="form">
        <span className="heading">Generate link</span>
        <lebel>Name of Admin</lebel><input placeholder="eg.Judith.. " type="text" className="input" />
        <lebel>Admin Number</lebel><input placeholder="0766.. " type="Phone" className="input" />
        <lebel>Name of Group</lebel><input placeholder="eg.Wafanya biashara dsm.." id="mail" type="text" className="input" />
        <lebel >Description</lebel>
        <textarea
          placeholder="eg.Namba za wafanya biashara kampuni ya ..."
          rows="10"
          cols="30"
          id="message"
          name="message"
          className="textarea"
        ></textarea>
        <div className="button-container">
          <div className="send-button">Submit</div>
          <div className="reset-button-container">
            <a href='/login'><div id="reset-btn" className="reset-button">
              Login
            </div></a>
            
          </div>
        </div>
      <a>  <p className='blue'>Forgot Link!? Do you!</p></a>
      </div>
    </div>
    </div>
    <Footer />
    </>
  )
}

export default Generate
